import React from 'react';
import { Card } from 'vindi-ds-components';
import EmptyState from '@templates/empty_state';
import styles from './styles';
import ChargesPendingEmptyHeadline from './headline';

function ChargesPendingEmptyState() {
  return (
    <Card css={styles}>
      <EmptyState>
        <EmptyState.Headline>
          <ChargesPendingEmptyHeadline />
        </EmptyState.Headline>
      </EmptyState>
    </Card>
  );
}

export default ChargesPendingEmptyState;
